import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '1rem',
    gap: '2rem',
  },
  textButtonIcon: {
    marginRight: '0.5rem',
  },
}));

export default useStyles;
